// tabs当前选中
export const ACTIVE_NAME = 'ACTIVE_NAME'
export const SET_ACTIVE_NAME = 'SET_ACTIVE_NAME'
export const FRONT_APPLY_STATE = 'FRONT_APPLY_STATE'
export const PAGE_CURRENT = 'PAGE_CURRENT'
export const LOAN_LIST_DATA = 'LOAN_LIST_DATA'
export const PAGE_COUNT = 'PAGE_COUNT'

export const SET_LOAN_LIST_DATA = 'SET_LOAN_LIST_DATA'
export const SET_PAGE_CURRENT = 'SET_PAGE_CURRENT'
export const SET_FRONT_APPLY_STATE = 'SET_FRONT_APPLY_STATE'
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT'

export const GET_MY_LOAN_LISTS_DATA = 'GET_MY_LOAN_LISTS_DATA'
export const GET_PAGE_CURRENT = 'GET_PAGE_CURRENT'

export const DELETE_LOAN_ITEM_FRONT_APPLY = 'DELETE_LOAN_ITEM_FRONT_APPLY'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/loanLists.js